import { render, staticRenderFns } from "./ApplicantStatus.vue?vue&type=template&id=f475fc76&scoped=true&"
import script from "./ApplicantStatus.vue?vue&type=script&lang=js&"
export * from "./ApplicantStatus.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStatus.vue?vue&type=style&index=0&id=f475fc76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f475fc76",
  null
  
)

export default component.exports